import styled from "styled-components"

const HorizontalHeader_s = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  &>div:not(:last-child) {
    margin-right: 14px;
  }

  &>div {
    display: flex;
    flex-direction: column;
  }

  label {
    margin-right: 6px;
  }

  .years-input {
    width: 40px;
  }

  .p-dropdown {
    width: 220px;
  }
`

const PercentLineHeader_s = styled.div`
  margin-bottom: 20px;

  input[type="text"] {
    width: 180px;
  }

  .p-dropdown {
    width: 210px;
  }

  label {
    display: block;
    margin-bottom: 6px;
  }

  &.percent-line-horizontal {
    display: flex;
    justify-content: start;
    align-items: center;

    div:first-child {
      margin-right: 34px;
    }
    .percent-line-radio-buttons {
      label {
        display: inline;
      }
      label:first-child {
        margin-right: 20px;
      }
      input[type=radio] {
        display: inline;
        vertical-align: initial;
      }
    }
  }
`

const PercentLineTable_s = styled.div`
  .p-datatable {
    width: 600px !important;

    .p-datatable-tbody > tr > td.automated.p-editable-column {
      width: 50px;
    }

    .p-datatable-tbody > tr > td > input {
      border: none !important;
      background: inherit;
    }
  }
`

export {
  HorizontalHeader_s,
  PercentLineHeader_s,
  PercentLineTable_s
}
